import React, { useContext, useEffect, useState } from "react";
import UserDataService from "../../services/User";
import { SingleUserJourneyList } from "../../components/List/SingleUserJourneyList";
import { useDisclosure } from "@chakra-ui/react";
import { UserGroupModel } from "../../components/Modals/UserGroupModel";
import { AdvanceNotificationModal } from "../../components/Modals/AdvanceNotificationModal";
import { userListContext } from "./ListContext";
import { SelectedUsersNotificationModal } from "../../components/Modals/SelectedUsersNotificationModal";
import { BsInfoCircleFill } from "react-icons/bs";
export const UserJourneyList = () => {
  // const token = localStorage.getItem("logged_in_user_token");
  const [modal, setModal] = useState("");
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [list, setList] = useState<any>([]);
  const [sortBy, setsortBy] = useState("updatedAt");
  const [level, setLevel] = useState("");
  const [pageSize, setPageSize] = useState(50);
  const [page, setPage] = useState(1);
  const [totalUsers, setTotalUsers] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [recentUsers, setRecentUsers] = useState(0);
  const [activeUsers, setActiveUsers] = useState(0);
  const [monthlyAddedUsers, setMonthlyAddedUsers] = useState(0);
  const [monthlyActiveUsers, setMonthlyActiveUsers] = useState(0);
  const { isallChecked, setIsallChecked } = useContext(userListContext);
  const [selectedData, setSelectedData] = useState<any>([]);
  console.log(selectedData);
  const handleSelectedData = (id: string, isChecked: boolean) => {
    setSelectedData((prevData: any) => {
      if (isChecked) {
        return [...prevData, id];
      } else {
        return prevData.filter((el: any) => {
          return el !== id;
        });
      }
    });
  };
  const fetchData = async () => {
    UserDataService.getUserJourney(sortBy, level, page, pageSize)
      .then((res: any) => {
        setList(res.data.data);
        setTotalUsers(res.data.totalCount);
        setTotalPages(res.data.totalPages);
        setRecentUsers(res.data.recentUsers);
        setActiveUsers(res.data.activeUsers);
        setMonthlyAddedUsers(res.data.currentMontNewhUsers);
        setMonthlyActiveUsers(res.data.currentMonthActiveUsers);
      })
      .catch((error: any) => {
        console.log(error);
      });
  };
  useEffect(() => {
    fetchData();
  }, []);
  return (
    <div className="main-wrapper">
      <div className="page_title py-2">Reachout - App Users </div>
      <div className="p-4">
        <div className="top_section_container">
          <div className="top_section_lower_container ">
            <div className="nested p-lg-0">
              <div className="input-group">
                <div className="btn-group w-100 ">
                  <button
                    type="button"
                    className="btn action-btn pl-4"
                    onClick={() => {
                      setModal("advanceFilter");
                      onOpen();
                    }}
                  >
                    Advance Notification Filter
                  </button>
                </div>
              </div>
            </div>
            <div className="nested p-lg-0">
              {/* User Count */}
              <div className="parent-booking-count pt-2">
                <div className="info-icon">
                  <BsInfoCircleFill color="#fdb508" fontSize="24px" />
                </div>
                <div className="info-content p-3 bg-light ml-2">
                  <div className="booking-text">
                    User added today :{" "}
                    <span className="booking-count">{recentUsers}</span>
                  </div>
                  <div className="booking-text">
                    User Active today :{" "}
                    <span className="booking-count">{activeUsers}</span>
                  </div>
                  <div className="booking-text">
                    Users added this month :{" "}
                    <span className="booking-count">{monthlyAddedUsers}</span>
                  </div>
                  <div className="booking-text">
                    Active Users this month :{" "}
                    <span className="booking-count">{monthlyActiveUsers}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="top_section_lower_container">
            <div className="nested  p-lg-0">
              <div className="input-group">
                <div className="btn-group w-100 ">
                  <button
                    type="button"
                    className="btn action-btn pl-4"
                    onClick={() => {
                      setModal("usermodal");
                      onOpen();
                    }}
                  >
                    Send notification to a group
                  </button>
                </div>
              </div>
            </div>

            <div className="nested  p-lg-0">
              <div className="input-group">
                <div className="btn-group w-100 ">
                  <button
                    type="button"
                    className={
                      selectedData.length <= 0
                        ? "btn action-btn disabledButton "
                        : "btn action-btn"
                    }
                    disabled={selectedData.length <= 0 ? true : false}
                    onClick={() => {
                      if (selectedData.length > 0) {
                        setModal("notificationmodal");
                        onOpen();
                      }
                    }}
                  >
                    Send notification to selected group
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="top_section_lower_container">
            <div className="nested  p-lg-0 ">
              <div className="input-group">
                <select
                  className="form-control filter-sec"
                  id="lead_status"
                  value={sortBy}
                  onChange={(e) => {
                    setsortBy(e.target.value);
                  }}
                >
                  <option value="">Select Sorting</option>
                  <option value="updatedAt">Sort by latest app usage</option>
                  <option value="createdAt">Sort by account created</option>
                </select>
              </div>
            </div>

            <div className="nested p-lg-0">
              <div className="">
                <select
                  className="form-control filter-sec"
                  id="lead_status"
                  value={level}
                  onChange={(e) => {
                    setLevel(e.target.value);
                  }}
                >
                  <option value="">Filter By Level</option>
                  <option value="1">1</option>
                  <option value="2">2</option>
                  <option value="3">3</option>
                  <option value="4">4</option>
                </select>
              </div>
            </div>
            <div className="nested p-lg-0">
              <div className="d-flex justify-content-end">
                <button
                  className="btn action-btn search-btn"
                  type="button"
                  onClick={() => fetchData()}
                >
                  Search
                </button>
              </div>
            </div>
          </div>
        </div>
        {modal === "notificationmodal" && (
          <SelectedUsersNotificationModal
            isOpen={isOpen}
            onClose={onClose}
            users={selectedData}
          />
        )}
        {modal === "usermodal" && (
          <UserGroupModel
            isOpen={isOpen}
            onClose={onClose}
            onOpen={onOpen}
            category={""}
          />
        )}
        {modal === "advanceFilter" && (
          <AdvanceNotificationModal
            isOpen={isOpen}
            onClose={onClose}
            onOpen={onOpen}
            category={""}
          />
        )}

        {/* Main secttion */}
        <div className="main-section">
          <table className="table">
            <thead>
              <tr>
                <th>
                  <div className="edit-icon mr-2">
                    <input
                      type="checkbox"
                      checked={isallChecked}
                      aria-label="Checkbox"
                      onChange={(e: any) => setIsallChecked(e.target.checked)}
                    />
                    Select{" "}
                  </div>
                </th>
                <th>S No.</th>
                <th>Last used at</th>
                <th>Account created at</th>
                <th>Pro Enabled</th>
                <th>Level</th>
                <th>Gender</th>
                <th>Age</th>
                <th>Location</th>
                <th>MMT</th>
                <th>Hope</th>
                <th>Assessment</th>
                <th>EHC</th>
                <th>Single</th>
                <th>Subscription</th>
                <th>Last 5 Notification</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {list && list.length > 0 ? (
                list.map((el: any, index: any) => (
                  <SingleUserJourneyList
                    key={el._id}
                    props={el}
                    id={el._id}
                    index={index}
                    func={handleSelectedData}
                  />
                ))
              ) : (
                <h1 className="no-data">No Data Found</h1>
              )}
            </tbody>
          </table>
        </div>
        <div className="row m-0 pagination pt-5">
          <div className="col-sm-6 p-lg-0">
            <p>
              Showing {(page - 1) * pageSize + 1} to{" "}
              {page * pageSize > totalUsers ? totalUsers : page * pageSize} of{" "}
              {totalUsers} Users
            </p>
          </div>
          <div className="col-sm-6 p-lg-0 text-right">
            <div className="btn-group" role="group">
              <button
                type="button"
                className={
                  page === 1
                    ? "btn action-btn disabledButton "
                    : "btn action-btn"
                }
                onClick={() => setPage(page - 1)}
                disabled={page === 1 ? true : false}
              >
                {"<< Previous"}
              </button>
              <button type="button" className="btn action-btn selected">
                {page}
              </button>
              <button
                type="button"
                className={
                  page === totalPages || totalPages === 0
                    ? "btn action-btn disabledButton "
                    : "btn action-btn"
                }
                onClick={() => setPage(page + 1)}
                disabled={
                  page === totalPages || totalPages === 0 ? true : false
                }
              >
                {"Next >>"}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
